import React from "react";
import {Button} from "react-bootstrap";

export function RequestError({onRefresh}: { onRefresh: Function }) {
    return (
        <div className="text-center py-10">
            <p>Error while loading data</p>
            <Button variant='primary' onClick={(e) => onRefresh()}>
                Refresh&nbsp;&nbsp;
                <span className="fas fa-sync"/>
            </Button>
        </div>
    )
}